export const RECEIVE_RESULTS = 'RECEIVE_RESULTS';

export function receiveResults(results, append=false) {
  return {
    type: RECEIVE_RESULTS,
    results,
    append: append
  }
}



// WEBPACK FOOTER //
// ./src/actions/results.js